import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-business-guide-bba-courses',
  templateUrl: './business-guide-bba-courses.component.html',
  styleUrls: ['./business-guide-bba-courses.component.scss']
})
export class BusinessGuideBbaCoursesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
